import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgentBuilderRoutingModule } from './agent-builder-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { PlainToolbarModule } from '../plain-toolbar/plain-toolbar.module';
import { PlainFooterModule } from '../plain-footer/plain-footer.module';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

import { AgentBuilderComponent } from './agent-builder/agent-builder.component';
import { AgentBuilderFormComponent } from './agent-builder-form/agent-builder-form.component';

@NgModule({
  declarations: [AgentBuilderComponent, AgentBuilderFormComponent],
  imports: [
    CommonModule,
    AgentBuilderRoutingModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    PlainToolbarModule,
    PlainFooterModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
  ],
})
export class AgentBuilderModule {}
